import React, { useContext } from "react";
import '../singapore.css' ;
import { Button } from "../components/ui/button";
import { Card} from "../components/ui/card";
import Banner1 from "../assets/Singapore_Page_Offer2_Int2.jpg";
import Banner2 from "../assets/Singapore_Page_Offer1_Int2.png";
import Banner3 from "../assets/SINGAPORE PAGE OFFER -INT2.png";
import { CurrencyContext } from "../components/CurrencyContext";

//  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowRight , faArrowLeft} from '@fortawesome/free-solid-svg-icons';
// import Banner1 from "../assets/Crusie_Deal_Banner_Final_genting.webp";
// import Banner2 from "../assets/Crusie_Deal_Banner_Final_royal.webp";
// import Banner3 from "../assets/Crusie_Deal_Banner_Final_Disney.webp"



const offerData = [
  {
    id: 1,
    name: "Genting Dream",
    imageUrl: Banner3,
    description: "Designed specifically for the Asian traveller, it offers a blend of familiar comforts, great service, and regional flavours. Choose from 2- and 3-night sailings from Singapore and Malaysia, covering Thailand, perfect for quick getaways.",
    offer: "3rd & 4th Guest FREE",
    nights: "2 & 3 Night Sailings"
  },
  {
    id: 2,
    name: "Ovation of the Seas",
    imageUrl: Banner3,
    description: "From Royal Caribbean International, brings together innovation at sea,thrilling activities and family-friendly fun for multigenerational travellers. From skydiving simulators and bumper cars to gourmet dining and Broadway-style shows, it’s packed with non-stop excitement it has something for everyone. Set sail on 3, 4, 5-night and longer itineraries from Singapore covering Malaysia and Thailand.",
    offer: "60% OFF on Second Guest + Kids Cruise FREE + Int2 special - Additional 5% OFF on select sailings",
    nights: "2 & 3 Night Sailings",
  },
  {
    id: 3,
    name: "Disney Adventure",
    imageUrl: Banner3,
    description: "The newest and largest ship in Singapore. It’s the kids’ favourite as they get to meet beloved Disney Characters, enjoy themed dining experiences and watch live shows. With 3, 4 and 5-night high-sea sailings from Singapore, every sailing promises magical moments for kids and grown-ups alike.",
    offer: "Int2special - Get 5% Off",
    nights: "2 & 3 Night Sailings"
  }
];



const curencylink = {

  Genting: {
  INR : "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&CruiseLine=9289&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&CruiseLine=9289&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&CruiseLine=9289&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc"
},

  "Disney": {
  "INR" :"https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&CruiseLine=4&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  "SGD" : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&CruiseLine=4&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  "USD" :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&CruiseLine=4&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc"
} ,

 "Ovation": {
  "INR" :"https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&CruiseLine=8&Ship=13717&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  "SGD" : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&CruiseLine=8&Ship=13717&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  "USD" :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&CruiseLine=8&Ship=13717&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc"
}
}

const CruiseLines = () => {

  const currency = useContext(CurrencyContext);
//   const [activeIndex, setActiveIndex] = useState(0);

//   const nextSlide = () => setActiveIndex((prev) => (prev + 1) % cruiseLinesData.length);
//   const prevSlide = () => setActiveIndex((prev) => (prev - 1 + cruiseLinesData.length) % cruiseLinesData.length);

  // return (
  //   <section className="cruise-section">
  //     <div className="cruise-container">
  //       <div className="cruise-header">
  //         <h2 className="cruise-title">Cruises From Singapore</h2>
  //         <p className="cruise-subtitle">
  //           Choose from world-class cruise lines offering unique experiences and unmatched service, all departing from Singapore.
  //         </p>
  //       </div>

  //       <div className="carousel-wrapper">
  //         <div
  //           className="carousel-track"
  //           // style={{ transform: `translateX(-${activeIndex * 100}%)` }}
  //         >
  //           {cruiseLinesData.map((cruise) => (
  //             <div className="carousel-slide" key={cruise.id}>
  //               <div className="card">
  //                 <div className="card-grid">
  //                   <div
  //                     className="card-image"
  //                     style={{ backgroundImage: `url('${cruise.imageUrl}')` }}
  //                   >
  //                     <div className="card-badge">{cruise.nights}</div>
  //                   </div>
  //                   <div className="card-content">
  //                        <div className="card-offer">
  //                       Special Offer: {cruise.offer}
  //                     </div>
  //                     <h3 className="card-title">{cruise.name}</h3>
  //                     {cruise.brand && <p className="card-brand">{cruise.brand}</p>}
  //                     <p className="card-description">{cruise.description}</p>
                     
  //                     <button className="view-button">View Cruises</button>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           ))}
  //         </div>

  //         {/* <button className="nav-button prev" onClick={prevSlide}><FontAwesomeIcon icon={faArrowLeft}/></button> */}
  //         {/* <button className="nav-button next" onClick={nextSlide}><FontAwesomeIcon icon={faArrowRight}/></button> */}

  //         {/* <div className="carousel-dots">
  //           {cruiseLinesData.map((_, index) => (
  //             <button
  //               key={index}
  //               className={`dot ${activeIndex === index ? "active" : ""}`}
  //               onClick={() => setActiveIndex(index)}
  //             />
  //           ))}
  //         </div> */}
  //       </div>
  //     </div>
  //   </section>
  // );

   return (

    <>
     <section className="cruise-section">
         <div className="cruise-container">
    <div className="cruise-header">
         <h2 className="cruise-title">Cruises From Singapore</h2>
         <p className="cruise-subtitle">
            Choose from world-class cruise lines offering unique experiences and unmatched service, all departing from Singapore.
         </p>
       </div>
       </div>
       </section>

    <section className="offers-section">
      <div className="offers-grid">
        {/* Left Column */}
        <div className="offers-left">
          {/* Villa Booking */}
          <Card className="offer-card group">
            <div className="card-image-wrapper">
              <img
                src={Banner2}
                alt="Luxury overwater villa with tropical scenery"
                fill
                className="card-image group-hover-scale"
              />
              <div className="card-gradient villa-gradient" />
            </div>
            <div className="card-content">
                <a href={curencylink.Genting[currency.currencyCode]} target="_self" >

              <div>
                <h3 className="card-title">{offerData[0].name}</h3>
                <p className="card-offer-left">{offerData[0].offer}</p>

                <p className="card-text">
                  {offerData[0].description}
                </p>
              </div>
              <div className="card-button-wrapper">
                <a href={curencylink.Genting[currency.currencyCode]} target="_self" >
                <Button className="card-button yellow" >
                  View Cruise
                </Button>
                </a>
              </div>
              </a>
            </div>
          </Card>

          {/* Photo Session */}
          <Card className="offer-card group">
            <div className="card-image-wrapper">
              <img
                src={Banner1}
                alt="Professional session by tropical waters"
                fill
                className="card-image group-hover-scale"
              />
              <div className="card-gradient photo-gradient" />
            </div>
            <div className="card-content">
                 <a href={curencylink.Disney[currency.currencyCode]} target="_self" >
              <div>
                <h3 className="card-title">{offerData[2].name}</h3>
                <p className="card-offer-left">{offerData[2].offer}</p>
                <p className="card-text">
                {offerData[2].description}
                </p>
              </div>
              <div className="card-button-wrapper">
                  <a href={curencylink.Disney[currency.currencyCode]} target="_self" >

                <Button className="card-button yellow">
                  View Cruise
                </Button>
                </a>
              </div>
              </a>
            </div>
          </Card>
        </div>

        {/* Right Column */}
        <Card className="offer-card large group">
          <div className="card-image-wrapper">
            <img
              src={Banner3}
              alt="Luxury white SUV transfer service with palm trees"
              fill
              className="card-image group-hover-scale"
            />
            <div className="card-gradient transfer-gradient" />
          </div>
          <div className="card-content">
                 <a href={curencylink.Ovation[currency.currencyCode]} target="_self" >
           
             <div>
              <h3 className="card-title large">{offerData[1].name}</h3>
              <p className="card-offer">{offerData[1].offer}</p>

              <p className="card-text large">
                {offerData[1].description}
              </p>
            </div>
            <div className="card-button-wrapper">
               <a href={curencylink.Ovation[currency.currencyCode]} target="_self" >


              <Button className="card-button white">
               View Cruise
              </Button>
              </a>
            </div>
            </a>
          </div>
        </Card>
      </div>
    </section>
    </>
   );
};

export default CruiseLines;
